import '../css/App.css';
import 'core-js/es6/promise';
import 'core-js/fn/object/assign';
import React, { Component } from 'react';
import CalcControl from "./CalcControl";
import 'whatwg-fetch';


const currency = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: 'code',
    minimumFractionDigits: 2
});

const percentage = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 3
});

class App extends Component {
    constructor(props) {
        super(props);

        this.onSliderChange = this.onSliderChange.bind(this);
        this.onSliderEnd = this.onSliderEnd.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.onModeChange = this.onModeChange.bind(this);
        this.calculate = this.calculate.bind(this);
        this.updateResults = this.updateResults.bind(this);
        this.formatCurrencyNumber = this.formatCurrencyNumber.bind(this);
        this.formatPercentNumber = this.formatPercentNumber.bind(this);

        const urlParams = new URLSearchParams(window.location.search);

        this.state = {
            buyingCosts: parseFloat(urlParams.get('buyingCosts')) || 65000.0,
            closingCostsFactor: parseFloat(urlParams.get('closingCostsFactor')) || 6.5,
            closingCosts: 4225.0,
            objectCosts: 69225.0,
            equity: parseFloat(urlParams.get('equity')) || 14000.0,
            duration: parseFloat(urlParams.get('duration')) || 5.0,
            rate: parseFloat(urlParams.get('rate')) || 3.0,
            output: {
                creditAmount: 55225.0,
                monthlyInstallment: 997.7209419229059,
                effectiveRate: 3.3662412325391835,
                totalRefund: 59863.256515374356,
                avail: 52830.55,
                monthlyBonus: 2.74,
                handlingFee: 3.0,
                deedRegistration: 1.2,
                monthlyActivityCharge: 5.4
            },
            referrer: urlParams.get('referrer') || '',
            objectType: urlParams.get('objectType') || '',
            target: urlParams.get('target') || 'reichert-immobilien'
        };
    }

    componentDidMount() {
        const state = { ...this.state };

        const closingCosts = state.buyingCosts * (this.state.closingCostsFactor / 100);
        state.closingCosts = closingCosts;
        state.objectCosts = state.buyingCosts + closingCosts;

        this.setState(state);
        this.calculate(state);
    }

    onSliderChange(key, value) {
        const state = { ...this.state };
        state[key] = value;

        if(key === 'objectCosts')
            state['equity'] = parseFloat((state[key] * 0.2).toFixed(2));
        else if(key === 'equity' && state['objectCosts'] < state[key] / 0.8)
            state['objectCosts'] = parseFloat((state[key] / 0.8).toFixed(2));

        this.setState(state);
    }

    onSliderEnd() {
        this.calculate(this.state);
    }

    onInputChange(value, key) {
        const state = { ...this.state };
        state[key] = parseFloat(value);

        if(key === 'buyingCosts') {
            const closingCosts = state[key] * (this.state.closingCostsFactor / 100);
            state.closingCosts = closingCosts;
            state.objectCosts = state[key] + closingCosts;
        }

        if(key === 'equity' && state['objectCosts'] < state[key] / 0.8)
            state['objectCosts'] = parseFloat((state[key] / 0.8).toFixed(2));

        this.setState(state);
        this.calculate(state);
    }

    onModeChange(e) {
        this.setState({ mode: e.target.value });
    }

    calculate(state) {
        const data = new FormData();
        data.append('objectCosts', state.objectCosts);
        data.append('monthlyInstallment', state.monthlyInstallment);
        data.append('equity', state.equity);
        data.append('duration', state.duration);
        data.append('rate', state.rate);
        data.append('mode', state.mode);

        window.fetch('https://www.kreditaustria.at/wp-json/creditcalc/calculate', {
            method: 'POST',
            referrerPolicy: "no-referrer",
            body: data
        })
        .then(response => response.json())
        .then(json => this.updateResults(json))
        .catch(error => console.log('error: ', error));
    }

    updateResults(data) {
        this.setState({
            output: {
                creditAmount: data.creditAmount,
                effectiveRate: data.effectiveRate,
                objectCosts: data.objectCosts,
                monthlyInstallment: data.monthlyInstallment,
                totalRefund: data.totalRefund,
                avail: data.avail,
                monthlyBonus: data.monthlyBonus,
                handlingFee: data.handlingFee,
                deedRegistration: data.deedRegistration,
                monthlyActivityCharge: data.monthlyActivityCharge
            }
        });

        if(window.hasOwnProperty('jQuery')) {
            window.jQuery('.creditcalc-form-hidden input[name=objectCosts]').val(this.formatCurrencyNumber(this.state.objectCosts));
            window.jQuery('.creditcalc-form-hidden input[name=equity]').val(this.formatCurrencyNumber(this.state.equity));
            window.jQuery('.creditcalc-form-hidden input[name=duration]').val(this.state.duration);
            window.jQuery('.creditcalc-form-hidden input[name=rate]').val(this.state.rate.toFixed(3));
            window.jQuery('.creditcalc-form-hidden input[name=creditAmount]').val(this.formatCurrencyNumber(data.creditAmount));
            window.jQuery('.creditcalc-form-hidden input[name=monthlyInstallment]').val(this.formatCurrencyNumber(data.monthlyInstallment));
        }
    }

    formatCurrencyNumber(input, symbol) {
        let result = currency.format(input);

        if(!isNaN(input) && Math.abs(input.toFixed(3) - input.toFixed(0)) < 0.01)
            result = currency.format(parseInt(input)).replace(',00', ',-');

        return symbol + ' ' + result.replace(/\u00a0EUR/g, '');
    }

    formatPercentNumber(input) {
        if(!isNaN(input) && input.toFixed(3) - input.toFixed(0) === 0)
            return percentage.format(parseInt(input)).replace(',000', '');

        return percentage.format(input);
    }

    render() {
        return (
            <div className="credit-calc-container">
                <form ref={this.formRef} className="credit-calc-container-inner" action={`https://www.kreditaustria.at/${this.state.target}`} method="post" target="_blank">
                    <h1 className="credit-calc-headline">
                        Unverbindliche<br />Finanzierungsanfrage
                        <svg className="credit-calc-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 102">
                            <g style={{ opacity: 0.9 }}>
                                <polygon style={{ fill: '#658da6' }} points="58.841 0 0 102 117.682 102 58.841 0"/>
                            </g>
                            <g style={{ opacity: 0.8 }}>
                                <polygon style={{ fill: '#658da6' }} points="58.841 102 58.841 0 128 0 58.841 102"/>
                            </g>
                        </svg>
                    </h1>

                    {this.state.advanced && <>
                        <div className="credit-calc-control">
                            <label className="credit-calc-control-label">Berechnung von</label>

                            <div className="credit-calc-control-inner">
                                <div className="form-field select credit-calc-control-select">
                                    <select className='form-control' name="mode" value={this.state.mode} onChange={this.onModeChange}>
                                        <option value="monthlyInstallment">Monatsrate</option>
                                        <option value="objectCosts">Kreditbetrag</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <br />
                    </>}

                    <CalcControl
                        label="Kaufpreis (EUR)"
                        name="buyingCosts"
                        currency={true}
                        decimals={0}
                        value={this.state.buyingCosts}
                        onInputChange={this.onInputChange}
                        tabIndex={1}
                        preventEnter
                    />

                    <CalcControl
                        label="Kaufnebenkosten ca. 6,5% vom Kaufpreis (EUR)"
                        subLabel="(Grunderwerbssteuer, Eintragungsgebühr, Vertragsgebühr)"
                        name="closingCosts"
                        currency={true}
                        value={this.state.closingCosts}
                        readOnly
                        tabIndex={-1}
                        preventEnter
                    />

                    <hr />

                    <CalcControl
                        className="credit-calc-gap"
                        label="Gesamtkaufpreis (EUR)"
                        name="objectCosts"
                        currency={true}
                        value={this.state.objectCosts}
                        readOnly
                        tabIndex={-1}
                        preventEnter
                    />

                    <CalcControl
                        label="abzüglich Eigenmittel (EUR)"
                        subLabel="20% vom Gesamtkaufpreis"
                        name="equity"
                        currency={true}
                        decimals={0}
                        value={this.state.equity}
                        onInputChange={this.onInputChange}
                        tabIndex={2}
                        preventEnter
                    />

                    <hr />

                    <CalcControl
                        className="credit-calc-gap"
                        label="benötigter Kreditbetrag (EUR)"
                        name="creditAmount"
                        currency={true}
                        value={this.state.output.creditAmount}
                        readOnly
                        tabIndex={-1}
                        preventEnter
                    />

                    <CalcControl
                        label="Laufzeit (Jahre)"
                        subLabel="Annahme *"
                        name="duration"
                        value={this.state.duration}
                        readOnly
                        tabIndex={-1}
                        preventEnter
                    />

                    <CalcControl
                        label="Zinssatz (%)"
                        subLabel="Annahme *"
                        name="rate"
                        decimals={3}
                        value={this.state.rate}
                        readOnly
                        tabIndex={-1}
                        preventEnter
                    />

                    <input type="hidden" name="referrer" value={this.state.referrer} readOnly />
                    <input type="hidden" name="objectType" value={this.state.objectType} readOnly />
                    <input type="hidden" name="creditAmount" value={parseFloat(this.state.output.creditAmount.toFixed(2))} readOnly />
                    <input type="hidden" name="monthlyInstallment" value={parseFloat(this.state.output.monthlyInstallment.toFixed(2))} readOnly />
                    <input type="hidden" name="effectiveRate" value={parseFloat(this.state.output.effectiveRate.toFixed(3))} readOnly />
                    <input type="hidden" name="totalRefund" value={parseFloat(this.state.output.totalRefund.toFixed(2))} readOnly />
                    <input type="hidden" name="avail" value={parseFloat(this.state.output.avail.toFixed(2))} readOnly />
                    <input type="hidden" name="monthlyBonus" value={parseFloat(this.state.output.monthlyBonus.toFixed(2))} readOnly />
                    <input type="hidden" name="handlingFee" value={parseFloat(this.state.output.handlingFee.toFixed(2))} readOnly />
                    <input type="hidden" name="deedRegistration" value={parseFloat(this.state.output.deedRegistration.toFixed(2))} readOnly />
                    <input type="hidden" name="monthlyActivityCharge" value={parseFloat(this.state.output.monthlyActivityCharge.toFixed(2))} readOnly />

                    <div className="credit-calc-monthly-installment">
                        <label className="credit-calc-monthly-installment-label">Monatsrate ab</label>
                        <h1>{this.formatCurrencyNumber(this.state.output.monthlyInstallment, 'EUR')}</h1>
                    </div>

                    <p className="credit-calc-credit-clarification">
                        * Repräsentatives Beispiel für einen Kreditvertrag mit einem Kreditbetrag von {this.formatCurrencyNumber(this.state.output.creditAmount, '€')} besichert
                        mit einer Hypothek Laufzeit {this.state.duration} Jahre, Zinssatz {this.formatPercentNumber(this.state.rate)} % p.a. variabel,
                        effektiver Zinssatz, {this.formatPercentNumber(this.state.output.effectiveRate)} % p.a. Einberechnete Kosten (jeweils einmalig vom Kreditbetrag):
                        Bearbeitungsgebühr {this.state.output.handlingFee} %, Grundbucheintragungsgebühr {this.state.output.deedRegistration} %. Kontoführung
                        vierteljährig {this.formatCurrencyNumber(this.state.output.monthlyActivityCharge * 3, '€')}. {this.state.duration * 12} monatliche
                        Raten zu {this.formatCurrencyNumber(this.state.output.monthlyInstallment, '€')} zu zahlender Gesamtbetrag {this.formatCurrencyNumber(this.state.output.totalRefund, '€')}, tatsächlicher
                        Auszahlungsbetrag {this.formatCurrencyNumber(this.state.output.avail, '€')} (Auszahlungsbetrag nach Abzug Kreditnebenkosten). Sämtliche Werte in der Berechnung verstehen sich als unverbindliche Richtwerte und sind von Bonität,
                        Volumen, Laufzeit, Lebensalter, Verwendungszweck und konkreter Besicherung abhängig. Die tatsächlichen Werte können, je nach kreditwährendem Institut von dieser Musterberechnung abweichen. Effektivverzinsung,
                        Gesamteinmalkosten und Gesamtbelastung werden nach Vorliegen der konkreten Bonitätsdaten berechnet bzw. alternative Finanzierungsvarianten in einem persönlichen Gespräch vorgestellt. Beispiel für linear
                        fallende Kreditrestschuldversicherung, Versicherungssumme = Kreditnominale, für einen 35 jährigen Nichtraucher ohne Erschwerniszulagen mit
                        einer Monatsprämie von {this.formatCurrencyNumber(this.state.output.monthlyBonus, '€')}.
                    </p>

                    <div className="credit-calc-credit-request-container">
                        {/* <a className="credit-calc-credit-request" href={`https://www.kreditaustria.at/anfrage?creditAmount=${this.state.output.creditAmount}&duration=${this.state.duration}&equity=${this.state.equity}&rate=${this.state.rate}`}>zur Kreditanfrage</a> */}
                        <button className="credit-calc-credit-request" onClick={this.onSubmit} tabIndex={3}>Weiter zur unverbindlichen Anfrage</button>
                    </div>
                </form>
            </div>
        );
    }
}

export default App;
